// package imports
import { useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { Box, Tabs } from '@mui/material';
import { Theme as MuiTheme } from '@mui/material/styles';

// local imports
import TabPanel from './SessionNoteComponents/TabPanel';
import { TabItem } from './SessionNoteComponents/TabItem';
import SessionNote from './SessionNoteComponents/SessionNote';
import EventNote from './SessionNoteComponents/EventNote';

const ObservationSessionNote = () => {
  const theme = useTheme() as MuiTheme;

  const [tabIndex, setTabIndex] = useState(0);

  return (
    <>
      <Box
        sx={{
          width: '95%',
          marginTop: '.4rem',
        }}
      >
        <Tabs
          value={tabIndex}
          onChange={(e, nv) => setTabIndex(nv)}
          aria-label="Note Tabs"
          centered
          variant="fullWidth"
          sx={{
            height: '30px',
            minHeight: '30px',
            '& button': {
              padding: '6px 16px',
            },
          }}
        >
          <TabItem
            label="Session Note"
            id="session-note-tab"
            aria-controls="session-note-tabpanel"
          />
          <TabItem
            label="Event Note"
            id="event-note-tab"
            aria-controls="event-note-tabpanel"
          />
        </Tabs>
      </Box>

      <TabPanel
        value={tabIndex}
        index={0}
        id="session-note-tabpanel"
        name="session-note-tabpanel"
        style={{
          backgroundColor: theme.palette.common.white,
          width: '95%',
          padding: '.25rem .25rem',
          boxShadow:
            '0 2px 2px 0 rgba(0, 0, 0, 0.14),0 3px 1px -2px rgba(0, 0, 0, 0.2),0 1px 5px 0 rgba(0, 0, 0, 0.12)',
          borderRadius: '0 0 6px 6px',
        }}
      >
        <SessionNote theme={theme} />
      </TabPanel>
      <TabPanel
        value={tabIndex}
        index={1}
        id="event-note-tabpanel"
        name="event-note-tabpanel"
        style={{
          backgroundColor: theme.palette.common.white,
          width: '95%',
          padding: '.25rem .25rem',
          boxShadow:
            '0 2px 2px 0 rgba(0, 0, 0, 0.14),0 3px 1px -2px rgba(0, 0, 0, 0.2),0 1px 5px 0 rgba(0, 0, 0, 0.12)',
          borderRadius: '0 0 6px 6px',
        }}
      >
        <EventNote theme={theme} />
      </TabPanel>
    </>
  );
};

export default ObservationSessionNote;
